import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import { FormattedMessage, injectIntl } from 'react-intl';

const AdminDriverRow = ({ driver, getDrivers, intl }) => {
  function deleteDriver() {
    const confirmMessage = intl.formatMessage({ id: 'driver.view.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      /*
      apiCalls.deleteDriver(driver.id)
        .then(() => {
          getDrivers();
        }).catch((errors) => {
        window.alert(utils.getErrorMessageFromResponse(errors, true));
      });
       */
    }
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/drivers/${driver.id}`} className="link">
          {driver.id}
        </Link>
      </th>
      <td>{driver.name}</td>
      <td>{driver.phoneNumber}</td>
      <td>{driver.vehicleType}</td>
      <td>
        <Link to={`/admin/drivers/edit/${driver.id}`} className="link">
          <FormattedMessage id={'admin.table.actions.edit'} />
        </Link>
        <br />
        <button className="btn btn-normal-link" onClick={deleteDriver}>
          <FormattedMessage id={'admin.table.actions.delete'} />
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminDriverRow.propTypes = {
  driver: PropTypes.object.isRequired,
  getDrivers: PropTypes.func.isRequired,
};

AdminDriverRow.defaultProps = {};

export default injectIntl(AdminDriverRow);
